(ns hai.library.prompts.create
  "Prompts creation page components"
  (:require
   [hai-model.model :as model]
   [hai.ui.components.form.core :as form]
   [hai.ui.components.form.input :as input]
   [hai.ui.components.new-design.button :as button]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.layout :as layout]
   [hai.web-app.util.fetch :as fetch]
   [kitchen-async.promise :as p]
   [lambdaisland.ornament :as o]
   [malli.util :as mu]))

(o/defstyled cancel-button button/small
  button/light
  ([]
   [:<>
    {:on-click (fn [_]
                 (>e [:routing/navigate [:ai-prompts/table]]))}
    "Cancel"]))

(o/defstyled update-button button/small
  button/dark
  [:&.disabled button/disabled]
  ([{:form/keys [on-submit valid?] :as form}]
   [:<>
    {:class (when (not valid?) "disabled")
     :on-click on-submit}
    "Create"]))

(o/defstyled form :div
  :flex :flex-col :gap-4
  [:.buttons :flex :gap-3]
  ([]
   [form/component
    {:id ::form
     :schema (mu/select-keys model/Prompt [:ai-prompt/title :ai-prompt/content])
     :on-submit (fn [{:ai-prompt/keys [title content]}]
                  (p/let [resp (fetch/post "/assistant/v0/ai-prompts"
                                           {:method :post
                                            :body {:title title
                                                   :content content}})]
                    (>e [:routing/navigate [:ai-prompts/table]])))
     :render (fn [{:form/keys [on-submit valid-value]
                   {:ai-prompt/keys [title content]} :form/fields
                   :as form}]
               [:<>
                [form/label title
                 [input/field title]]
                [form/label content
                 [input/expanding-textarea content]]
                [:div.buttons
                 [update-button form]
                 [cancel-button]]])}]))

(defn page
  [_]
  [layout/page
   [layout/breadcrumbs]
   [layout/heading]
   [layout/content
    [form]]])
